import { Card, CardHeader, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import request, { gql } from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";
import { allRoles, deleteRoleById } from "./roleData";
import _ from "lodash";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../../../components/MaterialDataGrid";
import PageLoading from "../../../../components/Loading/PageLoading";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialButton from "../../../../components/MaterialButton";
import Swal from "sweetalert2";
import { useAuthData } from "../../../context/loginContext/LoginContextProvider";
import RoleAccess from "../../../function/RoleAccess";

const RoleCreateTabel = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { access } = useAuthData();
  useEffect(() => {
    fetchdata();
  }, []);

  const RoleListTable = {
    columns: [
      {
        headerName: "S.No",
        field: "sno",
        name: "S.NO",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Role",
        field: "role",
        name: "role",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Role Description",
        field: "description",
        name: "description",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },

      {
        headerName: "Action",
        field: "Action",
        name: "Action",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: data?.map((v, i) => ({
      sno: i + 1,
      id: v?.id,
      role: _.capitalize(v?.role),
      description: _.capitalize(v?.description),
      createdBy: _.capitalize(v?.createdBy),
      createdOn: _.capitalize(v?.createdOn),
      Action: (
        <div
          style={{
            display: "flex",

            marginTop: "10px",
            alignItems: "center",
          }}
        >
          <RoleAccess modelName="Role Screen" component="ViewRole">
            <VisibilityIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/role/rolecreate/view-role`, {
                  state: { type: "view", data: v },
                })
              }
            />
          </RoleAccess>

          <RoleAccess modelName="Role Screen" component="UpdateRole">
            <EditIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/role/rolecreate/edit-role`, {
                  state: { type: "edit", data: v },
                })
              }
            />
          </RoleAccess>
          <RoleAccess modelName="Role Screen" component="DeleteRole">
            <DeleteIcon
              fontSize="small"
              className="actionIcon"
              onClick={() => handleDelete(v?.id)}
            />
          </RoleAccess>
        </div>
      ),
    })),
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure you want to delete this data?",
      text: "This action is irreversible and cannot be recovered.",
      icon: "question",
      showCancelButton: true,
    }).then(async (result) => {
      if (result?.isConfirmed) {
        setIsLoading(true);
        try {
          const res = await request(BASEURL, deleteRoleById, {
            roleId: id,
          });
          const status = res?.deleteRole?.success;
          const message = res?.deleteRole?.message;
          if (status) {
            Swal.fire({
              position: "top",
              icon: "success",
              title: message,
              showConfirmButton: true,
            }).then(() => {
              fetchdata();
            });
          } else {
            Swal.fire({
              position: "top",
              icon: "error",
              title: message,
              showConfirmButton: true,
            });
          }
        } catch (err) {
        } finally {
          setIsLoading(false);
        }
      }
    });
  };

  const fetchdata = () => {
    setIsLoading(true);
    request(BASEURL, allRoles)
      .then((res) => {
        setData(res?.allRoles[0]?.data);
      })
      .catch((err) => {
        const message =
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Something went wrong";
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Role List
                </MaterialTypography>
              </Stack>

              <RoleAccess modelName="Role Screen" component="CreateRole">
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={() =>
                    navigate("/role/rolecreate/add-role", {
                      state: { type: "add" },
                    })
                  }
                >
                  Role
                </MaterialButton>
              </RoleAccess>
            </Stack>
          }
        />
        {!isLoading && (
          <MaterialDataGrid
            // customHeight={550}
            rows={RoleListTable?.rows}
            columns={RoleListTable?.columns}
            // checkboxSelection={false}
            isSelectable={false}
            // onRowClick={onCustomerListClick}
            //   loading={pageState.loading}
            localeText={{
              noRowsLabel: (
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <MaterialTypography
                    variant="body2"
                    fontWeight="medium"
                    color="text"
                  >
                    No Role found
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    You have not yet add any role details. Click on the "Add
                    Role" button to start adding role details.
                  </MaterialTypography>
                </Stack>
              ),
            }}
          />
        )}

        {isLoading && <PageLoading />}
      </Card>
    </DashboardLayout>
  );
};

export default RoleCreateTabel;
